import { render } from "./GeoPage.vue?vue&type=template&id=6dc63280&scoped=true"
import script from "./GeoPage.vue?vue&type=script&lang=js"
export * from "./GeoPage.vue?vue&type=script&lang=js"

import "./GeoPage.vue?vue&type=style&index=0&id=6dc63280&scoped=true&lang=css"

import exportComponent from "/home/denis/Projects/tavria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc63280"]])

export default __exports__